import { type ComponentCreation } from './types'

export const createMuiLinearProgress = () =>
  ({
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: '9999px',
        },
        bar: {
          borderRadius: 'inherit',
        },
      },
    },
  }) satisfies ComponentCreation
